export function LoadingState({ label = "読み込み中..." }: { label?: string }) {
  return (
    <div className="loading-state">
      <div className="spinner" />
      <div>{label}</div>
    </div>
  );
}
